import { render, staticRenderFns } from "./assestAdd.vue?vue&type=template&id=213940c9&scoped=true"
import script from "./assestAdd.vue?vue&type=script&lang=js"
export * from "./assestAdd.vue?vue&type=script&lang=js"
import style0 from "./assestAdd.vue?vue&type=style&index=0&id=213940c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213940c9",
  null
  
)

export default component.exports